module.exports = __webpack_public_path__ + "img/p125.6f8fdf0f.jpg";